<template>
  <v-list-item v-if="!isEditing" class="grey lighten-4">
    <v-list-item-content>
      <v-list-item-subtitle class="blue-grey--text text--darken-4">{{ printKana }}</v-list-item-subtitle>
      <v-list-item-title class="title blue-grey--text text--darken-4">{{ printName }}{{ printRelationship }}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading" @click="edit">
            <v-icon small>fal fa-pencil</v-icon>
          </v-btn>
        </template>
        <span>編集する</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
  <v-container v-else>
    <v-subheader>名前</v-subheader>
    <v-row dense class="pb-4">
      <v-col cols="12" sm="6" class="px-3">
        <v-text-field label="姓" required
          v-model="form.name[0]"
          :rules="rules.name"
        />
      </v-col>
      <v-col cols="12" sm="6" class="px-3">
        <v-text-field label="名" required
          v-model="form.name[1]"
          :rules="rules.name"
        />
      </v-col>
      <v-col cols="12" sm="6" class="px-3">
        <v-text-field label="せい" required
          v-model="form.kana[0]"
          :rules="rules.kana"
        />
      </v-col>
      <v-col cols="12" sm="6" class="px-3">
        <v-text-field label="めい" required
          v-model="form.kana[1]"
          :rules="rules.kana"
        />
      </v-col>
      <v-col cols="12" class="px-3">
        <v-combobox required append-icon="fas fa-sort-down" no-filter
          v-model="form.relation"
          :items="meta.relation.items"
          :rules="rules.relation"
          label="続柄"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
export default {
  name: 'clientAboutGuardiansName',
  props: [
    'status',
    'data',
    'index'
  ],
  data () {
    return {
      meta: {
        relation: {
          items: [
            '父',
            '母',
            '祖父',
            '祖母',
            '夫',
            '妻',
            'おじ',
            'おば',
            '息子',
            '娘',
            '孫',
            '兄',
            '姉',
            '弟',
            '妹'
          ]
        }
      },
      form: {
        name: ['', ''],
        kana: ['', ''],
        relation: ''
      },
      rules: {
        name: [
          v => !!v || '必須項目です'
        ],
        kana: [
          v => !!v || '必須項目です',
          v => !/[^ぁ-ん]/.test(v) || '平仮名のみ入力有効です'
        ],
        relation: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function () {
      if (
        this.$props.data &&
        this.$props.data.name &&
        this.$props.data.name.length &&
        this.$props.data.kana &&
        this.$props.data.kana.length &&
        this.$props.data.relation
      ) {
        this.$set(this, 'form', {
          name: [
            this.$props.data.name.length > 0 ? this.$props.data.name[0] : '',
            this.$props.data.name.length > 1 ? this.$props.data.name[1] : ''
          ],
          kana: [
            this.$props.data.kana.length > 0 ? this.$props.data.kana[0] : '',
            this.$props.data.kana.length > 1 ? this.$props.data.kana[1] : ''
          ],
          relation: this.$props.data.relation
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          type: 'name' + (this.$props.index != null ? this.$props.index : '')
        }
      })
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        ['name' + (this.$props.index != null ? this.$props.index : ''), 'all'].includes(this.$props.status.editing)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.status.editing === ('name' + (this.$props.index != null ? this.$props.index : ''))
      )
    },
    isLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        ['name', 'all'].includes(this.$props.status.loading)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.status.loading === 'name'
      )
    },
    printName () {
      return (
        this.$props.data &&
        this.$props.data.name &&
        this.$props.data.name.length
      ) ? this.$props.data.name.join(' ') : ''
    },
    printKana () {
      return (
        this.$props.data &&
        this.$props.data.kana &&
        this.$props.data.kana.length
      ) ? this.$props.data.kana.join(' ') : ''
    },
    printRelationship () {
      return (
        this.$props.data &&
        this.$props.data.relation
      ) ? ('（' + this.$props.data.relation + '）') : ''
    }
  }
}
</script>
